export default __webpack_public_path__ + "static/media/EM1830.34I-42147_-25329_0.1992913d.jpg";